import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LmsLayoutComponent } from './lms-layout.component';
import { LmsContentComponent } from './lms-content/lms-content.component';
import { RouterModule, Routes } from '@angular/router';
import { DragulaModule } from 'ng2-dragula';
import { LmsContentEditorComponent } from './lms-content-editor/lms-content-editor.component';
import { FormsRoutingModule } from 'app/forms/forms-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ArchwizardModule } from 'angular-archwizard';
import { CustomFormsModule } from 'ngx-custom-validators';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { UiSwitchModule } from 'ngx-ui-switch';
import { QuillModule } from 'ngx-quill';
import { NgSelectModule } from '@ng-select/ng-select';
import { TagInputModule } from 'ngx-chips';
import { MatMenuModule } from '@angular/material/menu';
import { LmsListComponent } from './lms-list/lms-list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { PasswordGuard } from 'app/shared/auth/password.guard';
// import { NgCircleProgressModule } from 'ng-circle-progress';
// import { DragDropModule } from '@angular/cdk/drag-drop';
// import { MatIconModule } from '@angular/material/icon';
// import { MatSidenavModule } from '@angular/material/sidenav';
// import { MatListModule } from '@angular/material/list';

const routes: Routes = [
  { path: 'lmss/list', component: LmsListComponent },
  { path: 'lmss', component: LmsLayoutComponent ,
    canActivate: [PasswordGuard],
  },
  { path: 'event-lms', component: LmsLayoutComponent },
  { path: 'content', component: LmsContentComponent },
  { path: 'edit-content', component: LmsContentEditorComponent },
  { path: 'edit-video', component: LmsContentEditorComponent },

];

@NgModule({
  declarations: [
    LmsLayoutComponent,
    LmsContentComponent,
    LmsContentEditorComponent,
    LmsListComponent
  ],
  imports: [
    CommonModule,
    DragulaModule.forRoot(),
    FormsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    ArchwizardModule,
    CustomFormsModule,
    MatchHeightModule,
    UiSwitchModule,
    QuillModule.forRoot(),
    NgSelectModule,
    TagInputModule,
    MatMenuModule,
    DragDropModule,
    PipeModule,
    RouterModule.forChild(routes),
    // NgCircleProgressModule.forRoot({
    //   // set defaults here
    //   radius: 100,
    //   outerStrokeWidth: 16,
    //   innerStrokeWidth: 8,
    //   outerStrokeColor: "#78C000",
    //   innerStrokeColor: "#C7E596",
    //   animationDuration: 300,
    // }),
    NgxDatatableModule,
    NgxSpinnerModule,
    NgbModule,
  ],
  // exports: [RouterModule]
})
export class LmsLayoutModule { }
